import {
  GET_ALL_TEMPLATES,
  GET_TEMPLATES,
  UPDATE_TEMPLATE,
  ADD_TEMPLATE,
} from '../types'

const INITIAL_STATE = {
  getAlltemplate: [],
  getTemplateDetails: [],
  addTemplate:[],
  editTemplate:[],
  getCaseTemplate:[],
  total_records:null
}

const templateReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_TEMPLATES:
      return {
        ...state,
        getAlltemplate: payload.data,
        total_records: payload.data?.total_records,
      }
    case GET_TEMPLATES:
      return {
        ...state,
        getTemplateDetails: payload.data,
      }

    case UPDATE_TEMPLATE:
      return {
        ...state,
        editTemplate: payload,
      }
    case ADD_TEMPLATE:
      return {
        ...state,
        addTemplate: payload,
      }

    default:
      return state
  }
}

export default templateReducer
